import React, { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import { atualizarBusca } from '../../reducers/exame';
import { open, configure } from '../../reducers/alerta';
import axios from 'axios';
import { getHeaders } from '../../request';
import { temPermissaoRBAC } from '../../secutity/acl';
import {
    SttLoading,
    SttGrid,
    SttText,
    SttAutocomplete,
    SttInput,
    SttTranslateHook
} from '@stt-componentes/core';
import {
    SttModal,
    SttButton
} from '@stt-componentes/core-v2';
import { PERMISSOES, MODALIDADE } from '../../common/Constants';

const useStyles = makeStyles(theme => ({
    carregando: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%'
    },
    wrapperBotao: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    modalBody: {
        overflow: 'hidden'
    }
}));

const Invalidacao = (props) => {
    const { invalidar, setInvalidar, idExame, idInstituicao, idRede, callback } = props;
    const dispatch = useDispatch();
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const user = useSelector(state => state.index.user);

    const EXAME_API_BASE_URL = global.gConfig.url_base_exames;

    const classes = useStyles();
    const [motivos, setMotivos] = useState([]);
    const [motivo, setMotivoInvalidacao] = useState(null);
    const [observacao, setObservacao] = useState('');
    const [invalidando, setInvalidando] = useState(false);
    const [formValido, setFormValido] = useState(false);

    useEffect(() => {
        if (!motivos.length) {
            let params = { modalidade: MODALIDADE.SIGLA };
            if (idRede) {
                params.rede = idRede;
            }
            axios
                .get(`${EXAME_API_BASE_URL}/motivo-invalidacao`, { params, headers: getHeaders() })
                .then((response) => {
                    // Se não for médico, a seleção do motivo não é obrigatória pelo usuário
                    // É atribuído um motivo padrão
                    if (!temPermissaoRBAC(user, PERMISSOES.LAUDAR_EXAME)) {
                        const motivosTecnico = response.data.filter(m => m.motivo_padrao_tecnico);
                        setMotivos(motivosTecnico);
                        if (motivosTecnico.length) {
                            handleChangeMotivo(null, motivosTecnico[0]);
                        }
                        return;
                    }
                    setMotivos(response.data);
                })
                .catch(err => console.log(err));
        }
    }, []);

    useEffect(() => {
        // Técnicos e administradores não podem laudar e só precisam da observação textual
        if (!temPermissaoRBAC(user, PERMISSOES.LAUDAR_EXAME)) {
            if (observacao.trim()) {
                setFormValido(true);
            } else {
                setFormValido(false);
            }
        } else {
            // Laudadores precisam selecionar o motivo
            if (motivo) {
                setFormValido(true);
            } else {
                setFormValido(false);
            }
        }
    }, [observacao, motivo]);

    const fecharInvalidacao = () => {
        setMotivoInvalidacao(null);
        setInvalidar(false);
        if (callback) {
            callback();
        }
    }

    const handleChangeMotivo = (event, novoMotivo) => {
        setMotivoInvalidacao(novoMotivo);
    }

    const handleChangeObservacao = (event) => {
        setObservacao(event.target.value);
    }

    const invalidarExame = () => {
        setInvalidando(true);
        const payload = {
            idExame,
            instituicao: idInstituicao,
            motivo: motivo.id,
            observacao: observacao.trim()
        };
        axios
            .post(`${EXAME_API_BASE_URL}/invalidar`, payload, { headers: getHeaders() })
            .then(() => {
                setInvalidando(false);
                const alertConfig = {
                    title: strings.sucesso,
                    message: strings.exameInvalidado,
                    type: 'success',
                    open: true,
                    options: [
                        {
                            title: strings.ok,
                            onClick: () => {
                                dispatch(open(false));
                                fecharInvalidacao();
                                dispatch(atualizarBusca(true));
                            }

                        }
                    ],
                    onClose: () => {
                        dispatch(open(false));
                        fecharInvalidacao();
                        dispatch(atualizarBusca(true));
                    }
                };
                dispatch(configure(alertConfig));
            })
            .catch(err => {
                setInvalidando(false);
                console.log(err);
                const alertConfig = {
                    title: strings.erro,
                    message: strings.erroInvalidarExame,
                    type: 'error',
                    open: true,
                    options: [
                        {
                            title: strings.ok,
                            onClick: () => dispatch(open(false))

                        }
                    ],
                    onClose: () => dispatch(open(false))
                };
                dispatch(configure(alertConfig));
            });
    }

    return (
        <>
            <SttModal
                title={strings.invalidar}
                open={invalidar}
                outModalClose={fecharInvalidacao}
                iconClose={fecharInvalidacao}
                maxWidth="sm"
                fullWidth={true}
                children={
                    <div className={classes.modalBody}>
                        <SttGrid container spacing={3}>
                            <SttGrid item xs={12}>
                                {
                                    temPermissaoRBAC(user, PERMISSOES.LAUDAR_EXAME) &&
                                    <SttText variant="body1">{strings.textoInvalidar}</SttText> ||
                                    <SttText variant="body1">{strings.textoInvalidarExameObs}</SttText>
                                }
                            </SttGrid>
                            {
                                temPermissaoRBAC(user, PERMISSOES.LAUDAR_EXAME) &&
                                <SttGrid item xs={12}>
                                    <SttAutocomplete
                                        inputprops={{
                                            label: strings.motivo,
                                            required: true
                                        }}
                                        getOptionLabel={option => option.descricao}
                                        options={motivos}
                                        value={motivo}
                                        onChange={handleChangeMotivo}
                                    />
                                </SttGrid>
                            }
                            {
                                !temPermissaoRBAC(user, PERMISSOES.LAUDAR_EXAME) &&
                                <SttGrid item xs={12}>
                                    <SttInput
                                        value={observacao}
                                        label={strings.observacao}
                                        required
                                        onChange={handleChangeObservacao}
                                        multiline
                                        rows={3}
                                    />
                                </SttGrid>
                            }
                        </SttGrid>
                    </div>
                }
                footer={
                    <div>
                        <SttButton
                            variant="contained"
                            color="primary"
                            disabled={!formValido}
                            onClick={() => {
                                const alertConfig = {
                                    title: strings.atencao,
                                    message: strings.confirmarInvalidarExame,
                                    type: 'confirmation',
                                    open: true,
                                    options: [
                                        {
                                            title: strings.sim,
                                            onClick: () => {
                                                invalidarExame();
                                                dispatch(open(false));
                                            }
                                        },
                                        {
                                            title: strings.nao,
                                            onClick: () => dispatch(open(false))
                                        }
                                    ],
                                    onClose: () => dispatch(open(false))
                                };
                                dispatch(configure(alertConfig));
                            }}
                        >
                            {strings.confirmar}
                        </SttButton>
                        <SttButton variant="outlined" color="primary" onClick={fecharInvalidacao}>
                            {strings.cancelar}
                        </SttButton>
                    </div>
                }
            />
            <div className={classes.carregando}>
                <SttLoading
                    open={invalidando}
                    text={strings.invalidandoExame}
                />
            </div>
        </>
    );
};

Invalidacao.propTypes = {
    idExame: PropTypes.number.isRequired,
    invalidar: PropTypes.bool.isRequired,
    setInvalidar: PropTypes.func.isRequired,
    idRede: PropTypes.number
};

export default Invalidacao;